<template>
  <div class="ITEM m-b-2:mo">
    <p class="text-italic p-b-3">{{testimonial.quote}}</p>
    <div class="LINE"></div>
    <div class="p-t-2">{{testimonial.name}}</div>
  </div>
</template>

<script>

export default {
  name: 'short-testimonial',
  props: {
    testimonial: {
      type: Object,
      require: true,
    },
  },
};

</script>

<style lang="scss" scoped>
@import "~@homeservices/design-kit/tools";

.ITEM {
  text-align: left;
  display: flex;
  flex: 1 1 auto;
  flex-direction: column;
  background-color: $color-gray20;
  padding: 2 *$unit;
}
.LINE {
  width: 33%;
  border-bottom: solid 2px $color-depot;
}
</style>
